import * as React from 'react'

export const StudyPeriod = () => (
  <svg
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='-1.5 -3 27 27'
    xmlSpace='preserve'
    width="1em" height="1em" fill="currentColor"
  >
    <g id='PLcogC.tif_00000088123049966259420060000005015746951506410929_'>
      <path d='M4.49 19.95V2.55C4.54 1.13 5.5.52 6.91.54c2.49.02 4.97.01 7.46 0 .67 0 1.25.22 1.74.69 1.28 1.22 2.56 2.44 3.86 3.65.57.53.84 1.17.83 1.95-.01 3.69 0 7.37 0 11.06.07 1.74.14 3.68-2.01 4.07H6.5c-1.07-.21-1.81-.94-2.01-2.01zM14.27 1.8H6.9c-.73 0-1.16.42-1.16 1.15v16.6c0 .73.43 1.15 1.16 1.15h11.47c.74 0 1.16-.42 1.16-1.17V6.81c-2.93-.01-4.27.2-4.86-.46-.51-.58-.45-1.85-.4-4.55zm1.25.61v2.82c0 .28.05.33.33.33 1-.01 1.99.02 2.99-.01-1.11-1.06-2.2-2.08-3.32-3.14z' />
      <path d='M7.96 10.16c-.49 0-.81-.44-.63-.86.11-.26.32-.39.61-.39h9.1c.5 0 .82.44.63.87-.12.27-.34.38-.64.38H7.96zM17.07 12.25c.49 0 .8.44.62.87-.11.26-.33.39-.61.39-.64 0-9.2 0-9.29-.02a.623.623 0 0 1-.49-.68c.04-.32.3-.56.65-.56h9.12zM10.88 15.6c.41 0 .69.26.7.62.01.37-.29.64-.7.64h-2.9c-.4 0-.69-.26-.69-.63s.28-.62.69-.63h2.9z' />
    </g>
  </svg>
)
